import { render, staticRenderFns } from "./alertModal.vue?vue&type=template&id=8df8805e&"
import script from "./alertModal.vue?vue&type=script&lang=ts&"
export * from "./alertModal.vue?vue&type=script&lang=ts&"
import style0 from "./alertModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports